import React from 'react';
import classNames from 'classnames';
import { makeStyles } from 'housecall-ui';

type Props = {
  onClick: () => void;
  children?: React.ReactChildren;
  additionalClass: string;
};

const useStyles = makeStyles(() => ({
  reset: {
    border: 'none',
    display: 'block',
    color: 'inherit',
    textAlign: 'inherit',
  },
}));

export const PlainButton = ({ onClick, children, additionalClass }: Props) => {
  const { reset } = useStyles();

  return (
    <button type="button" className={classNames(reset, additionalClass)} onClick={onClick}>
      {children}
    </button>
  );
};
